import { BaseViewSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { InventoryViewType } from "./inventory-view-type";

export const saveInventoryView = {
  name: "saveInventoryView" as const,
  input: z.object({ viewType: InventoryViewType, view: BaseViewSchema }),
  output: z.object({}),
};
